import axios from 'axios';

export default {
   
    recordAttendance(meetingId) {
        var options = {
            url: window.apiUrl + '/ta-meeting/attendance',
            method: 'POST',
            data: { meetingId: meetingId },
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };

        return axios.request(options).then(function(response) {
            return response;
        });
    },
    get() {
        var options = {
            url: window.apiUrl + '/ta-meetings',
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getCheckins() {
        var options = {
            url: window.apiUrl + '/global-checkins',
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getMine() {
        var options = {
            url: window.apiUrl + '/my-ta-meetings',
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getOne(id) {
        var options = {
            url: window.apiUrl + '/ta-meeting/' + id,
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    toggleSignup(id, toggle) {
        var options = {
            url: window.apiUrl + '/ta-meeting-signup',
            method: 'POST',
            data: {
                signup: {
                    meetingId: id,
                    toggle: toggle
                }
            },
            headers: { 'Authorization': 'Bearer ' + localStorage.token }
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
}



// WEBPACK FOOTER //
// ./src/services/ta-meetings/index.js